import { AbschnittDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model';
import { GlobalEnumsAceFormulartyp } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-formulartyp';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Dictionary } from 'typescript-collections';
import { NavigationItem } from '../models/navigation-item.model';

@Injectable({
  providedIn: 'root'
})
export class FormularService {
  constructor(protected router: Router) { }

  public getRouteObjectThrough(abschnitt: AbschnittDisplayModel): NavigationItem {
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.Anlagen) {
      return this.createRoute(abschnitt.id, `attachments/${abschnitt.id}`, 'attachment-icon');
    }
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.Finanzierung || abschnitt.formularTyp == GlobalEnumsAceFormulartyp.FinanzierungmitFPImport) {
      return this.createRoute(abschnitt.id, `finance-data/${abschnitt.id}`, 'finance-icon'); 
    }
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.Organisation) {
      return this.createRoute(abschnitt.id, `contact-data/${abschnitt.id}`, 'contact-icon');
    }
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.AntragstellerKontakt) {
      return this.createRoute(abschnitt.id, `applicant-form/${abschnitt.id}`, 'contact-icon');
    }
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.Projektdetails) {
      return this.createRoute(abschnitt.id, `project-data/${abschnitt.id}`, 'project-icon');
    }
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.Fragen) {
      return this.createRoute(abschnitt.id, `questions/${abschnitt.id}`, 'questions-icon');
    }
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.Meilensteine) {
      return this.createRoute(abschnitt.id, `schedule/${abschnitt.id}`, 'schedule-icon');
    }
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.DetailsStipendium) {
      return this.createRoute(abschnitt.id, `stipendium/${abschnitt.id}`, 'stipendium-icon');
    }
    if (abschnitt.formularTyp == GlobalEnumsAceFormulartyp.GutachtenminusBegutachtung){
      return this.createRoute(abschnitt.id, `review-detail/${abschnitt.id}`, 'begutachtung-icon');
    }
    return this.createRoute();
  }

  public createRoute(id?: string, link?: string, icon?: string, queryParams?: Dictionary<string, string>): NavigationItem {
    var navItem: NavigationItem = new NavigationItem();
    
    navItem.id = id ?? '';
    navItem.link = link ?? '';
    navItem.icon = icon ?? '';
    
    return navItem;
  }

  
}
